/**
 * Utility functions for translating training test names
 */

import { TFunction } from 'i18next';

/**
 * Get translated test name from test_id and level
 * Uses the training.json translation keys structure: tests.{level}.{testId}.title
 */
export const getTranslatedTestName = (
  testId: string,
  testLevel: string | null | undefined,
  t: TFunction
): string => {
  if (!testId || !testLevel) {
    return testId || 'Test inconnu';
  }

  // Build the translation key
  const translationKey = `tests.level${testLevel}.${testId}.title`;
  
  // Try to get the translation
  const translated = t(translationKey);
  
  // If translation exists and is different from the key, return it
  if (translated && translated !== translationKey) {
    return translated;
  }
  
  // Fallback to test_id if no translation found
  return testId;
};

/**
 * Get translated test description from test_id and level
 */
export const getTranslatedTestDescription = (
  testId: string,
  testLevel: string | null | undefined,
  t: TFunction
): string => {
  if (!testId || !testLevel) {
    return '';
  }

  const translationKey = `tests.level${testLevel}.${testId}.description`;
  const translated = t(translationKey);
  
  if (translated && translated !== translationKey) {
    return translated;
  }
  
  return '';
};

/**
 * Determine exercise type from test_id
 */
export const getExerciseType = (testId: string): string => {
  const id = testId.toLowerCase();
  
  if (id.includes('putt')) return 'putting';
  if (id.includes('chip')) return 'chipping';
  if (id.includes('wedg')) return 'wedging';
  if (id.includes('bunker')) return 'bunker';
  if (id.includes('iron') || id.includes('fer')) return 'iron';
  if (id.includes('fairwaywood') || id.includes('bois')) return 'fairwaywood';
  if (id.includes('driver')) return 'driver';
  
  return 'other';
};
